import { render } from "./GoalKRCommentActivity.vue?vue&type=template&id=d38afde8"
import script from "./GoalKRCommentActivity.vue?vue&type=script&lang=js"
export * from "./GoalKRCommentActivity.vue?vue&type=script&lang=js"
script.render = render

export default script